import React from 'react';
import Icon from './Icon';
import { CASE_STUDIES } from '../data/content';

export default function CaseStudies() {
  return (
    <section id="case-studies" className="section">
      <div className="container">
        <div className="section-header reveal">
          <span className="eyebrow">Proven Results</span>
          <h2 className="section-title">Success Stories That Speak in Numbers</h2>
          <p className="section-subtitle">
            A snapshot of the measurable outcomes we've delivered for our clients.
          </p>
        </div>

        <div className="case-grid">
          {CASE_STUDIES.map((c, i) => (
            <div className="case-card reveal" key={c.title} style={{ transitionDelay: `${i * 0.08}s` }}>
              <div className="case-top">
                <div className="case-icon"><Icon name={c.icon} size={22} /></div>
                <div className="case-metric">{c.metric}</div>
              </div>
              <span className="case-label">{c.label}</span>
              <h4>{c.title}</h4>
              <p>{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}